<template>
  <InputTableContainer
    :loading="$apollo.loading"
    :headers="headers"
    :data="data"
    :actions="actions"
    :sortBy="sortBy"
    :sortDesc="sortDesc"
    type="crew"
  >
    <template v-slot:toolbar-right>
      <CrewCreateDropdown />
    </template>
  </InputTableContainer>
</template>

<script>
import { get } from 'vuex-pathify'
import InputTableContainer from '@/components/InputTableContainer'
import CrewCreateDropdown from './CrewCreateDropdown'
import CrewEditModal from './CrewEditModal'
import CrewDeleteModal from './CrewDeleteModal'

export default {
  name: 'CrewContainer',

  components: {
    InputTableContainer,
    CrewCreateDropdown
  },

  data: () => ({
    actions: [
      {
        title: 'Redigera',
        icon: 'mdi-pencil',
        component: CrewEditModal,
        type: 'edit'
      },
      {
        title: 'Ta bort',
        icon: 'mdi-delete',
        component: CrewDeleteModal,
        type: 'delete'
      }
    ],
    sortDesc: false,
    sortBy: ['duty_date'],
    headers: [
      {
        text: 'Tågnr.',
        value: 'train_number'
      },
      {
        text: 'Tjänstedatum',
        value: 'duty_date'
      },
      {
        text: 'Från plats',
        value: 'from'
      },
      {
        text: 'till plats',
        value: 'to'
      },
      {
        text: '',
        value: 'actions',
        sortable: false,
        filterable: false,
        align: 'right'
      }
    ]
  }),

  computed: {
    crewDeviations: get('crew/data'),

    data() {
      return Object.values(this.crewDeviations)
    }
  },

  beforeDestroy() {
    this.$store.set('crew/data', {})
  }
}
</script>
